import { useTranslation } from "react-i18next";
import "./LanguageSwitcher.css";

const LANGUAGES = ["en", "it"] as const;

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.language.startsWith("it") ? "it" : "en";

  return (
    <div className="lang-switcher" role="group" aria-label="Language">
      {LANGUAGES.map((lng) => (
        <button
          key={lng}
          type="button"
          className={`lang-switcher-btn ${current === lng ? "active" : ""}`}
          aria-pressed={current === lng}
          onClick={() => i18n.changeLanguage(lng)}
        >
          {lng.toUpperCase()}
        </button>
      ))}
    </div>
  );
}

export default LanguageSwitcher;
